import { inject, Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingController = inject(LoadingController);
  private loading: HTMLIonLoadingElement | null = null;

  constructor() { }

  async presentLoading(message: string = "") {
    const options = message ? { message } : {};
    if (this.loading) {
      await this.loading.dismiss();
      this.loading = null;
    }
    this.loading = await this.loadingController.create(options)
    await this.loading.present();
  }

  async dismissLoading() { 
    if (this.loading) {
      await this.loading.dismiss();
      this.loading = null;
    }
  }
}
